import React from 'react';
import {observer} from 'mobx-react';
import {Button, PriorityIcon} from '@priority-software/priority-style-react';
import {executeAdvancedSearch} from '../../Searches/actions/filters';

export const ClearSearchButton = observer(props => {
    const {
        searchesStore: {formSelected},
        currentForm
    } = props.formsStore;

    const clearSearch = () => {
        formSelected.clearFilters();
        executeAdvancedSearch(formSelected);
    };

    const isShowClearSearchButton = () => {
        if (currentForm && formSelected && formSelected.isFilterd) {
            return true;
        }
        return false;
    };
    return isShowClearSearchButton() ? (
        <Button
            skin="text"
            componentClasses="clear-search-button"
            prefixIcon={PriorityIcon.clear}
            onClick={clearSearch}
        >
            {props.children}
        </Button>
    ) : null;
});
